/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Substitution_Utilization_RateInputs */

const en_forms_users_settings_substitution_utilization_rate = /** @type {(inputs: Forms_Users_Settings_Substitution_Utilization_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

const de_forms_users_settings_substitution_utilization_rate = /** @type {(inputs: Forms_Users_Settings_Substitution_Utilization_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

/**
* | output |
* | --- |
* | "Rate" |
*
* @param {Forms_Users_Settings_Substitution_Utilization_RateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_substitution_utilization_rate = /** @type {((inputs?: Forms_Users_Settings_Substitution_Utilization_RateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Substitution_Utilization_RateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_substitution_utilization_rate(inputs)
	return de_forms_users_settings_substitution_utilization_rate(inputs)
});